"use client";

import { PrismicNextLink } from "@prismicio/next";
import { motion } from "framer-motion";

export const MotionPrismicNextLink = motion.create(PrismicNextLink);
